import React, {useEffect, useRef} from 'react';
import {View, TouchableOpacity, StyleSheet, Animated, Easing} from 'react-native';

import MoonSvg from '../../../components/svgs/MoonSvg';
import SunSvg from '../../../components/svgs/SunSvg';
import {useDarkMode} from '../DarkModeContext';
import {THEME_TRANSITION_MS, getThemeTransitionStyle} from '../theme';

function DarkModeToggle() {
    const {isDarkMode, toggleDarkMode} = useDarkMode();
    const progress = useRef(new Animated.Value(isDarkMode ? 0 : 1)).current;

    useEffect(() => {
        Animated.timing(progress, {
            toValue: isDarkMode ? 0 : 1,
            duration: THEME_TRANSITION_MS,
            easing: Easing.bezier(0.22, 1, 0.36, 1),
            useNativeDriver: true,
        }).start();
    }, [isDarkMode, progress]);

    const sliderTranslateX = progress.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 32],
    });

    const moonOpacity = progress.interpolate({
        inputRange: [0, 1],
        outputRange: [1, 0.35],
    });

    const sunOpacity = progress.interpolate({
        inputRange: [0, 1],
        outputRange: [0.35, 1],
    });

    return (
        <TouchableOpacity
            onPress={toggleDarkMode}
            activeOpacity={0.95}
            style={[
                styles.container,
                isDarkMode ? styles.containerDark : styles.containerLight,
            ]}
        >
            <Animated.View style={[
                styles.slider,
                isDarkMode ? styles.sliderDark : styles.sliderLight,
                {
                    transform: [{translateX: sliderTranslateX}],
                }
            ]}/>
            <View style={styles.iconsRow}>
                <Animated.View style={[styles.iconWrapper, {opacity: moonOpacity}]}>
                    <MoonSvg
                        width={18}
                        height={18}
                        fill={isDarkMode ? '#3CA6F5' : '#8FA0C7'}
                    />
                </Animated.View>
                <Animated.View style={[styles.iconWrapper, {opacity: sunOpacity}]}>
                    <SunSvg
                        width={18}
                        height={18}
                        fill={isDarkMode ? '#8FA0C7' : '#3CA6F5'}
                    />
                </Animated.View>
            </View>
        </TouchableOpacity>
    );
}

export default DarkModeToggle;

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 4,
        borderRadius: 100,
        width: 72,
        height: 40,
        position: 'relative',
        ...getThemeTransitionStyle('background-color'),
    },
    containerDark: {
        backgroundColor: 'rgba(248, 250, 253, 0.1)',
    },
    containerLight: {
        backgroundColor: '#E8EDF6',
    },
    iconsRow: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        zIndex: 2,
    },
    iconWrapper: {
        width: 32,
        height: 32,
        borderRadius: 100,
        justifyContent: 'center',
        alignItems: 'center',
    },
    slider: {
        position: 'absolute',
        left: 4,
        top: 4,
        width: 32,
        height: 32,
        borderRadius: 100,
        ...getThemeTransitionStyle('background-color,box-shadow'),
    },
    sliderDark: {
        backgroundColor: '#0E161A',
        shadowColor: 'rgba(0, 0, 0, 0.25)',
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.35,
        shadowRadius: 6,
    },
    sliderLight: {
        backgroundColor: '#FFFFFF',
        borderWidth: 1,
        borderColor: '#D9E2F0',
        shadowColor: 'rgba(0, 0, 0, 0.12)',
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.18,
        shadowRadius: 5,
    },
});